<template>    
    <div class="tile is-child box">
        <p class="title">Menu</p>
        <!-- Aside menus start -->
        <aside class="menu">
            <p class="menu-label">
                General
            </p>
            <ul class="menu-list">
                <!-- <a class="is-active">Dashboard</a> -->
                <li><router-link to="/">Dashboard</router-link></li>
                <!-- <li><router-link to="/">Profile</router-link></li> -->
            </ul>
            <p class="menu-label">
                Administration
            </p>
            <ul class="menu-list">
                <li><router-link to="/methods">Methods</router-link></li>
                <li><router-link to="/validationplantemplates">Validation Plans</router-link></li>
                <li><router-link to="/">Experimental Plans</router-link></li>
                <li><router-link to="/">Experimental Datasets</router-link></li>
                <li><router-link to="/">Reports</router-link></li>
            </ul>        
            </aside>
        <!-- Aside menus end -->

    </div>
</template>

<script>
export default {
    
}
</script>
